import React, { useEffect, useState } from 'react';
import Heading from '../../../../components/typography';
import { PageHeader } from '../../../../constants/style/common.styled';
import { COLORS } from '../../../../constants/style/color';
import Button from '../../../../components/button';
import { taxPeriodHeader } from '../../../../constants/table-headers/taxPeriodHeader';
import Table from '../../../../components/table';
import { type ModalStatusType, type TableParamsType } from '../../../../types/common';
import InitialValuesForm from '../../../../constants/initialValues';
import AnimationWrapper from '../../../../components/animation/animationWrapper';
import TaxYearModal from './taxYearModal';
import { useBoolean, useGetTablePreferences, usePostTablePreferences } from '../../../../hooks';
import useGetTaxPeriodList from '../../../../hooks/get/useGetTaxPeriodList';
import useWealthlaneTaxApi from '../../../../hooks/useWealthlaneTaxApi';
import { uniq, uniqBy } from 'lodash';
import {
  DynamicTable,
  withDynamicTableContext,
  useDynamicTable,
  useTableSchemaLoader,
} from '@wealthlane/table-builder';
import Spinners from '../../../../components/spinner';
import { axiosInstance } from '../../../../services/apiInterceptor';

const TaxYear = (): JSX.Element => {
  const { handleRequest } = useWealthlaneTaxApi();
  // const [tableInfo, setTableInfo] = useState<TableParamsType>(InitialValuesForm.tableParams);
  const { tableInfo, setTableInfo } = useDynamicTable();

  useEffect(() => {
    setTableInfo(InitialValuesForm.tableParams);
  }, []);
  const [modalStatus, setModalStatus] = useState<ModalStatusType>('Edit');
  const { value: isModalOpen, setFalse: closeModal, setTrue: openModal } = useBoolean(false);
  const [isHovering, setIsHovering] = useState<string>('');
  const { data: taxPeriodLists, isLoading, status } = useGetTaxPeriodList(handleRequest, tableInfo);
  const [initialValue, setInitialValue] = useState<any>(InitialValuesForm.taxPeriod);
  const { schemaData, isTableSchemaLoading } = useTableSchemaLoader({
    identifier: 'TAX_PERIOD_TABLE_LIST',
    baseUrl: process.env.REACT_APP_WEALTHLANE_API_ENDPOINT,
  });
  const [headerList, setHeaderList] = useState<string[]>([]);

  // const taxPeriodList = uniqBy(taxPeriodLists?.items, (list) => list?.name);
  const data = React.useMemo(() => taxPeriodLists?.items || [], [taxPeriodLists, isLoading]);

  const { data: tablePreferences } = useGetTablePreferences(handleRequest, 'Tax Period');

  useEffect(() => {
    tablePreferences != null && setHeaderList([...tablePreferences]);
  }, [tablePreferences]);

  const { mutate: postTablePreference, isLoading: tablePrefLoading } =
    usePostTablePreferences(handleRequest);

  const handleSavePreference = (value: string[]): void => {
    const prefPayload = {
      tableName: 'Tax Period',
      preferences: value,
    };
    postTablePreference(prefPayload);
  };

  const tableActions = [
    {
      action: 'Edit',
      onClick: (id: string, rowData: any) => {
        setInitialValue(rowData);
        openModal();
      },
      id: 'editTaxPeriodAction',
    },
  ];
  const tableHeaderList = taxPeriodHeader({ actions: schemaData?.columns, tableActions })
    .filter((item) => item.isSubHeader)
    .map((item) => {
      // console.log('item', item);

      return {
        label: item.Header,
        value: item.accessor,
      };
    });

  const taxperiodHeader = (): any[] => {
    return taxPeriodHeader({ actions: schemaData?.columns, tableActions }).filter(
      (item) => item.isSubHeader === false || headerList.includes(item.accessor)
    );
  };

  const schema = React.useMemo(
    () => ({
      columns: taxperiodHeader(),
      options: schemaData?.options as any,
    }),
    [schemaData]
  );

  if (isTableSchemaLoading) return <Spinners containerClassName='h-screen' />;

  return (
    <div id="taxPeriodPageContainer">
      <div className='flex justify-between items-center' id="taxPeriodPageHeader">
        <PageHeader id="taxPeriodPageHeaderContent">
          <Heading variant='h3' title={`Tax Period`} id="taxPeriodPageTitle" />
          <Heading
            variant='body-s'
            title={`View all the users present in your company.`}
            color={`${COLORS.Gray}`}
            id="taxPeriodPageDescription"
          />
        </PageHeader>
        <Button
          variant={'primary'}
          title={'Create Tax Period'}
          icon='add_circle_outline'
          onClick={() => {
            openModal();
            setModalStatus('Add');
            setInitialValue(InitialValuesForm.taxPeriod);
          }}
          id="createTaxPeriodButton"
        // loading={loading}
        />
      </div>
      <DynamicTable
        schema={schema}
        data={data}
        totalCounts={taxPeriodLists?.totalCount ?? 10}
        loading={status}
        tableColumnList={tableHeaderList}
        selectedColumnList={headerList}
        tablePreferenceLoading={tablePrefLoading}
        handleColumnSave={handleSavePreference}
        id="taxPeriodTable"
      />
      {/* <Table
        columns={taxPeriodHeader({ actions, tableActions })}
        data={data}
        loading={status}
        totalCounts={data?.totalCount ?? 10}
        showPagination={true}
        tableInfo={tableInfo}
        setTableInfo={setTableInfo}
        setIsHovering={setIsHovering}
      /> */}

      <AnimationWrapper>
        {isModalOpen && (
          <TaxYearModal
            isModalOpen={isModalOpen}
            closeModal={closeModal}
            modalStatus={modalStatus}
            setModalStatus={setModalStatus}
            loading={false}
            initialValue={initialValue}
            setInitialValue={setInitialValue}
            id="taxYearModal"
          // federalTaxDetails={federalTaxListByFinancialYear}
          // operationYear={operationYear}

          // tableInfo={tableInfo}
          // setTableInfo={setTableInfo}
          //   dataRow={dataRow}
          />
        )}
      </AnimationWrapper>
    </div>
  );
};

export default withDynamicTableContext(TaxYear, false, axiosInstance);
